<div class="work-popup modal-dialog">
  <div class="modal-content">
    <div class="name_icon">
      <div class="name-icon-title">
        <div class="add-content-text-container">
          <p class="add-content-text">Add Content</p>
        </div>
        <div class="close-add-content-popup">
          <mat-icon (click)="closePopUp()">close</mat-icon>
        </div>
      </div>
    </div>
    <div class="add_form_container">
      <form [formGroup]="contentForm" method="post" class="add-social-media" enctype="multipart/form-data">
        <div class="form-group">
          <input class="form-control content-add-input" type="text" formControlName="name" placeholder="Name" tabindex="-1"
                 [ngClass]="{'has-error': editContentControl['name'].invalid && editContentControl['name'].touched}">
          <div *ngIf="editContentControl['name'].invalid && editContentControl['name'].touched" class="validation">
            <small *ngIf="editContentControl['name'].errors!['required'] || editContentControl['name'].errors!['whitespace']">Name is required</small>
            <small *ngIf="editContentControl['name'].errors!['minlength']">Name should be at least 2
              characters</small>
            <small *ngIf="editContentControl['name'].errors!['maxlength']">Name cannot exceed 20 characters</small>
          </div>
        </div>
        <div class="form-group types-font-size">
          <mat-form-field appearance="fill">
            <mat-select placeholder="Content Type" class="" formControlName="contentType" tabindex="-1" required>
              <mat-option *ngFor="let platformType of getPlatformTypes()" class="types-font-size" [value]="platformType">
                {{platformType}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="editContentControl['contentType'].invalid && editContentControl['contentType'].touched"
               class="validation platform-type-valid-message">
            <small *ngIf="editContentControl['contentType'].errors!['required']">Platform type is required</small>
            <small *ngIf="editContentControl['contentType'].errors!['invalidPlatformType']">
              Please select a valid Platform Type
            </small>
          </div>
        </div>
        <div class="form-group">
          <input type="file" tabindex="-1" *ngIf="showFileInput" id="files" class="form-control choose-icon"
                 [accept]="getAcceptFileType()"
                 (change)="onFileSelected($event)" formControlName="contentIcon">
          <div
            *ngIf="contentForm.get('contentIcon')?.touched && showFileInput"
            class="validation">
            <small *ngIf="fileSizeExceeded" >File size should not exceed 2MB</small>
            <small *ngIf="showError">Image is required</small>
          </div>
          <div class="image-preview image add-content-icon" *ngIf="selectedFile">
            <img [src]="getImageAsSource(this.selectedFile)" alt="Image preview">
            <div class="delete-img-content-add">
                <mat-icon (click)="removeImage()" class="close-content-icon">close</mat-icon>
            </div>
          </div>
        </div>
        <br>
        <div class="buttons-container-admin">
          <div class="buttons-side w-100">
            <button mat-button class="save-btn" type="submit" (click)="onSubmit()">Save</button>
            <button mat-button class="cancel-btn" type="button" (click)="closePopUp()">Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
